import axios from "axios";
import { useEffect, useState } from "react";


const useSingleProduct = (id) => {
    const url=`https://rocky-ravine-79485.herokuapp.com/products/${id}`
    const [singleProduct, setSingleProduct] = useState([]);
    useEffect(()=>{
     axios.get(url).then(res=>setSingleProduct(res)) 
    },[]);
  return [singleProduct, setSingleProduct];
    
};

export default useSingleProduct;